<template>
  <w-icon-wrapper
    :height='24'
    :width='21.6'
    icon-name='work-nav-project-managment-icon'
    view-box='0 0 21.6 24'
  >
    <path
      id="_03_Projektverwaltung_Icon"
      data-name="03_Projektverwaltung_Icon"
      d="M122.4-896a2.311,2.311,0,0,1-1.695-.705,2.311,2.311,0,0,1-.705-1.7v-16.8a2.311,2.311,0,0,1,.705-1.7,2.311,2.311,0,0,1,1.695-.705h5.01a3.272,3.272,0,0,1,1.29-1.725,3.574,3.574,0,0,1,2.1-.675,3.6,3.6,0,0,1,2.145.675,3.3,3.3,0,0,1,1.275,1.725h4.98a2.311,2.311,0,0,1,1.7.705,2.311,2.311,0,0,1,.705,1.7v16.8a2.311,2.311,0,0,1-.705,1.7,2.311,2.311,0,0,1-1.7.705Zm0-2.4h16.8v-16.8h-2.4v3.6h-12v-3.6h-2.4Zm8.4-16.8a1.161,1.161,0,0,0,.855-.345A1.161,1.161,0,0,0,132-916.4a1.161,1.161,0,0,0-.345-.855,1.161,1.161,0,0,0-.855-.345,1.161,1.161,0,0,0-.855.345,1.161,1.161,0,0,0-.345.855,1.161,1.161,0,0,0,.345.855A1.161,1.161,0,0,0,130.8-915.2Z"
      transform="translate(-120 920)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavProjectManagment' };
</script>

